import script from "./VerifyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyView.vue?vue&type=script&setup=true&lang=ts"

import "./VerifyView.vue?vue&type=style&index=0&id=2a952d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a952d04"]])

export default __exports__